<template>
  <TirPmDropdown
    ref="dropdownTaskLocation"
    class="choose-project-dropdown"
    width="16rem"
    popoverWidth="21rem"
    :options="localItems"
    :showOnHover="true"
    :size="TirPmDropdownSizeEnum.Light"
    :selected-option="modelValue"
    :isSearchLocal="false"
    :isHiddenSearch="true"
    :isExcludeSelected="false"
    @updateSearch="getItems"
    optionListScrollHeight="24rem"
  >
    <template #target="slot">
      <div class="choose-project-dropdown_target" :class="{ sel: modelValue }">
        <div style="max-width: 200px" v-if="!modelValue">
          Расположение тикета <span style="color: red">*</span>
        </div>
        <template v-else>
          <div v-for="(el, idx) of breadcrumbs" :key="idx">
            <div class="namespace" v-if="el instanceof NamespaceModel">
              <TirPmSvg
                :url="el.IconUrl"
                class="namespace-item__namespace-icon"
                style="font-size: 1rem;"
                :color="el.Color"
              />
              <div class="namespace-title_hidden" :class="{ title_visible: true }">
                {{ el.Name }}
              </div>
              /
            </div>
            <div class="namespace" v-if="el instanceof GroupModel">
              <FolderIcon class="namespace-item__namespace-icon" />
              <div class="namespace-title_hidden" :class="{ title_visible: true }">
                {{ el.Name }}
              </div>
              /
            </div>
            <div class="namespace" v-if="el instanceof QueueTasksModel">
              <ListBulletIcon class="namespace-item__namespace-icon" />
              <div class="namespace-title_hidden" :class="{ title_visible: true }">
                {{ el.Name }}
              </div>
            </div>
          </div>
        </template>
        <ChevronDownIcon
          v-if="!modelValue"
          class="choose-project-dropdown_target_arrow"
          :class="{ open: slot.isOpened }"
        />
      </div>
    </template>
    <template #optionList="slot">
      <div
        class="choose-project-dropdown_option"
        :class="{ selected: modelValue?.Id == slot.option.Id.toString() }"
        @click.stop="selectProject(slot.option)"
      >
        <TaskLocation :item="slot.option" @onChange="onChangeSub" ></TaskLocation>
      </div>
    </template>
  </TirPmDropdown>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API

import { TirPmDropdown, TirPmDropdownSizeEnum, TirPmIconView, TirPmSvg } from "tir-components";
import { onBeforeMount } from "vue";
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
import { TaskParameterTypeEnum } from "../task-parameter";
import { PropType } from "vue";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  FolderIcon,
  ListBulletIcon,
} from "tir-style-system/icons/outline";
import { GroupModel, NamespaceModel, QueueTasksModel } from "../sidebar/models";
import { TaskLocation } from ".";

const visibleIdx = ref<Array<string>>([]);
/**API сервис */

/**Параметры */
const props = defineProps({
  modelValue: { type: Object as PropType<QueueTasksModel> },
  /**Тип проекта */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**
   * дерево данныхё
   */
  items: { type: Array as PropType<NamespaceModel[]>, default: [] },
});
/**События */
const emit = defineEmits<{ "update:modelValue": [QueueTasksModel] }>();

/**Список проектов */
const localItems = ref<(NamespaceModel | GroupModel | QueueTasksModel)[]>([]);

/**Перед рендером */
onBeforeMount(() => getItems());
onMounted(async () => {
  //  await getItems();
});
watch(
  () => props.items,
  async (value) => {
    if (value.length > 0) await getItems();
  },
);
const dropdownTaskLocation = ref();
/**Получить список проектов */
const getItems = async (value: string = "") => {
  localItems.value = props.items.map((item) => item);
};
const breadcrumbs = ref([]);
function onChangeSub(item: NamespaceModel | QueueTasksModel | GroupModel, isShow: boolean) {
  if (item instanceof QueueTasksModel) {
    emit("update:modelValue", item);
    dropdownTaskLocation.value.close();
    breadcrumbs.value = getBreadcrumbs(item.Id);
    return;
  }

  if (isShow) {
    insertAfter(
      localItems.value.findIndex((i) => i.Id == item.Id),
      item.Groups as any,
    );
    insertAfter(
      localItems.value.findIndex((i) => i.Id == item.Id),
      item.QueueTasks as any,
    );
    return;
  }

  if (item instanceof NamespaceModel) {
    localItems.value = localItems.value.filter(
      (i) =>
        !item.Groups.some((group) => group.Id == (i.Id as any)) &&
        !item.QueueTasks.some((task) => task.Id == i.Id) &&
        !(item.Id == (i as any)?.NamespaceId),
    );
    return;
  }

  localItems.value = localItems.value.filter(
    (i) =>
      !item?.Groups.some((group) => group.Id == (i.Id as any)) &&
      !item?.QueueTasks.some((task) => task.Id == i.Id),
  );
}
/**Выбор проекта */
const selectProject = (project: NamespaceModel) => {
  if (project instanceof QueueTasksModel) {
    emit("update:modelValue", project);
    dropdownTaskLocation.value.close();
    console.log(project);
  }
};
/**Вставить элементы в массив после определенного элемента */
const insertAfter = (index: number, newItems: NamespaceModel[]) => {
  localItems.value.splice(index + 1, 0, ...newItems);
};

/** */
function getBreadcrumbs(taskId) {
  const breadcrumbs = [];
  let currentTask = localItems.value.find((task) => task.Id === taskId);
  let namespace = localItems.value.find(
    (task) => task.Id === (currentTask as QueueTasksModel).NamespaceId,
  );
  while (currentTask) {
    breadcrumbs.unshift(currentTask);
    const tmp = localItems.value.find((task) => task.Id === (currentTask as any)?.ParentGroupId);
    currentTask = tmp;
  }

  breadcrumbs.unshift(namespace);

  return breadcrumbs;
}
</script>

<style lang="scss" scoped>
.choose-project-dropdown {
  // margin-bottom: 1rem;
  margin-bottom: unset;
  .namespace {
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    &-item__namespace-icon {
      width: 1rem;
    }
    &-title_hidden {
      margin-left: 0.5rem;
      margin-right: 1rem;
    }
  }
  .dd-project-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
  }

  &.tir-pm-dropdown {
    width: 100% !important;
  }

  &_text {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &_target {
    position: relative;
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0 2rem 0 0.75rem;
    background: var(--neutral-translucent-20);
    max-width: 200px;
    border-radius: 0.375rem;
    color: var(--text-primary, #272d37);
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

    &_arrow {
      position: absolute;
      top: 50%;
      right: 0.75rem;
      transform: translateY(-50%);
      width: 1rem;
      height: 1rem;
      transition: 0.2s linear;

      &.open {
        transform: translateY(-50%) rotate(-180deg);
      }
    }
  }
  &_target.sel {
    background: unset;
    max-width: unset;
    flex-wrap: wrap;
    height: auto;
  }

  .tir-pm-dropdown__label.light {
    display: none;
  }

  &_option {
    position: relative;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0 0.75rem;
    transition: 0.2s linear;
    cursor: pointer;

    &:hover,
    &.selected {
      background: var(--neutral-translucent-5);
    }

    &_check {
      display: none;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.75rem;
      width: 1.5rem;
      height: 1.5rem;
    }

    &.selected {
      .choose-project-dropdown_option_check {
        display: block;
      }
    }
  }
}
</style>